"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tdcClient = void 0;
const axios_1 = __importDefault(require("axios"));
const envConfig_1 = require("../../utils/helpers/config/envConfig");
/**
 * Cliente HTTP para comunicação com a API da TDC (tienda del chavo).
 */
exports.tdcClient = axios_1.default.create({
    baseURL: envConfig_1.envConfig.apiURL,
});
